import styled from 'styled-components';

export const StyledPatientUpdatePersonalData = styled.div`
   padding-right: 12px;
   display: flex;
   flex-direction: column;
   gap: 40px;
`;
StyledPatientUpdatePersonalData.displayName = 'StyledPatientUpdatePersonalData';
